<!-- src/app/layout/sidebar/sidebar.component.html -->

<!-- Overlay mobile -->
@if (mobileOpen()) {
<div class="sidebar-overlay" (click)="closeMobile()"></div>
}

<nav class="sidebar" [class.collapsed]="collapsed()" [class.mobile-open]="mobileOpen()">

    <!-- Header -->
    <div class="sidebar-header">
        <div class="logo-wrap">
            <!-- <a class="layout-topbar-logo" routerLink="/sys">
                <img src="./assets/img/lionsysShort.png" alt="Logo" class="h-10 w-auto" />
            </a> -->
            @if (!collapsed()) {
            <a class="layout-topbar-logo" routerLink="/sys">
                <img src="./assets/img/ghmIcono.png" alt="Logo GHM" class="h-8 w-auto" />
                <span class="logo-text">GHM <strong>Ingeniería</strong></span>
            </a>
            }
        </div>
        <button class="collapse-btn desktop-only" (click)="toggleCollapse()">
            <i class="pi" [class.pi-chevron-left]="!collapsed()" [class.pi-chevron-right]="collapsed()"></i>
        </button>
        <button class="collapse-btn mobile-only" (click)="closeMobile()">
            <i class="pi pi-times"></i>
        </button>
    </div>

    <!-- Perfil compacto -->
    @if (!collapsed()) {
    <div class="user-card">
        <div class="user-avatar">{{ auth.fullName().charAt(0) }}</div>
        <div class="user-info">
            <span class="user-name">{{ auth.fullName() }}</span>
            <span class="user-role">{{ auth.role() }}</span>
        </div>
    </div>
    }

    <!-- Selector de división (solo ADMIN/SUPERVISOR) -->
    @if (!collapsed() && (auth.isSupervisor() || auth.hasRole('ADMIN'))) {
    <div class="division-selector">
        <label class="nav-section-label">División</label>
        <p-select [options]="divisionOptions()" optionLabel="label" optionValue="value" placeholder="Todas"
            styleClass="sidebar-division-select" appendTo="body" (onChange)="onDivisionChange($event.value)" />
    </div>
    }

    <!-- Navegación por secciones -->
    <div class="nav-section">
        @for (section of visibleSections(); track section.label) {

        @if (!collapsed()) {
        <span class="nav-section-label">{{ section.label }}</span>
        } @else {
        <div class="nav-section-divider"></div>
        }

        <ul class="nav-list">
            @for (item of section.items; track item.route) {
            <li>
                <a class="nav-item" [routerLink]="item.route" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: item.exact ?? false}" [title]="collapsed() ? item.label : ''">
                    <i class="nav-icon" [ngClass]="item.icon"></i>
                    @if (!collapsed()) {
                    <span class="nav-label-text">{{ item.label }}</span>
                    }
                    @if (item.badge && !collapsed()) {
                    <span class="nav-badge">{{ item.badge }}</span>
                    }
                </a>
            </li>
            }
        </ul>

        }
    </div>

    <!-- Footer -->
    <div class="sidebar-footer">
        <button class="nav-item logout-btn" (click)="logout()" [title]="collapsed() ? 'Cerrar sesión' : ''">
            <i class="pi pi-sign-out nav-icon"></i>
            @if (!collapsed()) {
            <span class="nav-label-text">Cerrar sesión</span>
            }
        </button>
    </div>

</nav>